/**
 * @flow
 * @relayHash d5be897db454207d9ac935cc32710d73
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteMachineInput = {|
  id: string
|};
export type DeleteMachineMutationVariables = {|
  input: DeleteMachineInput
|};
export type DeleteMachineMutationResponse = {|
  +deleteMachine: {|
    +deletedId: string
  |}
|};
export type DeleteMachineMutation = {|
  variables: DeleteMachineMutationVariables,
  response: DeleteMachineMutationResponse,
|};
*/


/*
mutation DeleteMachineMutation(
  $input: DeleteMachineInput!
) {
  deleteMachine(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMachineInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteMachine",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMachinePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteMachineMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteMachineMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteMachineMutation",
    "id": null,
    "text": "mutation DeleteMachineMutation(\n  $input: DeleteMachineInput!\n) {\n  deleteMachine(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cb4dbb4c19fe40d1789411eed867c65e';
module.exports = node;
